import {InputAdornment, TextField, Typography} from "@mui/material";
import React from "react";
import {divide, formatCurrency, multiply} from "../../../helpers";
import {Colors, Container, Text} from "../../../ui";
import {minPartialPaymentInCents} from "../../helpers";
import {getAmountValidationHelperText} from "./utils";

interface ICustomPaymentBox {
  isValid: boolean;
  amount: number | undefined;
  totalBalance: number;
  setAmount: (amount: number) => void;
  title?: string;
}

export const CustomPaymentBox = ({isValid, totalBalance, amount, setAmount, title}: ICustomPaymentBox) => {
  return (
    <Container fullWidth>
      {title && (
        <Text fontWeight={"medium"} sx={{alignItems: "start", width: "100%"}}>
          {title}
        </Text>
      )}
      <TextField
        value={amount ? divide(amount, 100) : null}
        type={"number"}
        fullWidth
        onChange={(event) => setAmount(multiply(Number(event.target.value), 100))}
        error={!isValid}
        helperText={getAmountValidationHelperText({isValid, amount, totalBalance})}
        InputProps={{
          style: {borderRadius: "8px"},
          slotProps: {
            input: {
              style: {fontWeight: 500},
              min: totalBalance < minPartialPaymentInCents ? 0.01 : divide(minPartialPaymentInCents, 100),
              max: divide(totalBalance, 100),
            },
          },
          startAdornment: (
            <InputAdornment position="start">
              <Typography sx={{color: "text.primary", fontWeight: 500}}>{"$"}</Typography>
            </InputAdornment>
          ),
        }}
        sx={{backgroundColor: Colors.bw.white}}
      />
      <Text size={14} sx={{color: Colors.grey._700}}>
        (Maximal amount {formatCurrency(totalBalance)})
      </Text>
    </Container>
  );
};
